import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useWarehouseModel } from "../warehouseModel";
import { IWarehouseDetail } from "../warehouseService";
import { useDictModel } from "../../dict/dictModel";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, disableWarehouse
    } = useWarehouseModel();
    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IWarehouseDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '仓库编码',
            width: 180,
            dataIndex: 'code',
            fixed: "left",
        }, {
            title: '仓库名称',
            width: 160,
            dataIndex: 'name',
            fixed: "left",
            render: text => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '仓库类型',
            width: 160,
            dataIndex: 'typeName',
        },  {
            title: '仓库货位总数',
            width: 160,
            dataIndex: "shelfNum"
        }, {
            title: '联系人',
            width: 160,
            dataIndex: "contact"
        },{
            title: '联系电话',
            width: 160,
            dataIndex: "phone"
        },{
            title: '创建日期',
            width: 180,
            dataIndex: "createTime"
        }, {
            title: '备注',
            width: 300,
            dataIndex: 'note',
        }, 
        // {
        //     title: '状态',
        //     width: 120,
        //     dataIndex: 'status',
        //     render: (text, record) => (
        //         <Switch
        //             checkedChildren={"开启"}
        //             unCheckedChildren={"关闭"}
        //             checked={+(record.status ?? 0) ? true : false}
        //             onChange={(checked: boolean, e: MouseEvent) => {
        //                 e.stopPropagation();
        //                 disableWarehouse(record.id, checked ? 1 : 0)
        //             }}
        //         />
        //     ),
        // }
    ];


    //点击行选高亮
    const onRow = (record: IWarehouseDetail) => {
        let findObj = selectedRowKeys.find(item => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter(item => item.id !== record.id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            setSelectedRowKeys(origin => [...origin, record]);
        }
    };


    return (
        <Table
            rowKey={record => record.id}
            rowSelection={{
                //全部选中时 (存row[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
                        : setSelectedRowKeys((origin) => {
                            let changeRowId = changeRows.map(item => item.id);
                            return origin.filter(item => changeRowId.indexOf(item.id) < 0)
                        });
                },
                onSelect: (record, selected, selectedRows) => onRow(record),
                selectedRowKeys: selectedRowKeys.map(item => item.id)
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
